export const GRAVITY_WEBSITE_HANDOFF_QUERY_KEY = 'websiteHandoffId';
export const GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY = 'gravityWebsiteHandoff';
export const GRAVITY_WEBSITE_HANDOFF_HISTORY_STATE_KEY = 'gravityWebsiteHandoffId';
export const GRAVITY_WEBSITE_HANDOFF_READY_EVENT = 'gravityWebsiteHandoffReady';
export const GRAVITY_WEBSITE_HANDOFF_TTL_MS = 7 * 24 * 60 * 60 * 1000;
